import routes from "./routes";
import roleAndPermissions from "./permissions";
import { RiGroupLine } from "react-icons/ri";
import { GoOrganization } from "react-icons/go";
import { RiFileChartLine } from "react-icons/ri";

const menus = [
  {
    label: "Reports",
    requiredPermissions: ["*"],
    type: "group",
    children: [
      {
        key: routes.DASHBOARD.path,
        icon: <RiFileChartLine />,
        label: "Sales Tracking",
        requiredPermissions: ["*"],
      },
    ],
  },
  {
    label: "User Management",
    requiredPermissions: [roleAndPermissions.CustomerManagement.view],
    type: "group",
    children: [
      {
        key: routes.USERS.path,
        icon: <RiGroupLine />,
        label: "Users",
        requiredPermissions: [roleAndPermissions.CustomerManagement.view],
      },
    ],
  },
  {
    label: "Settings",
    requiredPermissions: [roleAndPermissions.CustomerManagement.view],
    type: "group",
    children: [
      {
        key: routes.BRAND.path,
        icon: <GoOrganization />,
        label: "Brands",
        requiredPermissions: [roleAndPermissions.CustomerManagement.view],
      },
    ],
  },
];

export default menus;
